export default __webpack_public_path__ + "static/media/play-store.7e81d3c4.svg";